import { createAction, props } from '@ngrx/store';

import { File, PatchSelfPublishFile, SelfPublish } from '../self-publishes.interface';

export const setSelfPublish = createAction('[Self Publish Component] Set Self Publish', props<{ selfPublish: SelfPublish }>());

export const updateSelfPublish = createAction('[Self Publish Component] Update Self Publish', props<{ selfPublish: SelfPublish }>());

export const updateSelfPublishFile = createAction('[Self Publish Component] Update Self Publish File', props<{ file: File }>());

export const deleteFile = createAction('[Self Publish Component] Delete File', props<{ id: string }>());

export const request = {
  loadSelfPublish: createAction('[Request/Api Self Publish] Load Self Publish', props<{ id: string }>()),
  changeSelfPublish: createAction(
    '[Request/Api Self Publish] Change Self Publish',
    props<{ id: string; payload: { accepted?: boolean; paid?: boolean } }>()
  ),
  patchSelfPublishFile: createAction('[Request/Api Self Publish] Update File', props<{ id: string; payload: PatchSelfPublishFile }>())
};
